/* PH CRO V7 - actual Kommo holder, independent of missing body.template-product class. */
(function () {
  'use strict';
  function init() {
    var body = document.body;
    if (!body || !document.querySelector('product-info, product-component, [id^="MainProduct-"], [id^="ProductInfo-"]')) return;
    var mq = window.matchMedia('(max-width: 749px)');
    var selectors = '.shopify-payment-button, shopify-accelerated-checkout, .product-form__buttons, .product-form__submit, form[action*="/cart/add"] button[type="submit"], .ph-sticky-atc__actions';
    var queued = false;
    function visible(el) {
      var rect = el.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && rect.top < window.innerHeight - 55 && rect.bottom > 0;
    }
    function chatOpen() {
      var holder = document.querySelector('.amo-button-holder');
      var btn = document.getElementById('amobutton');
      return !!((holder && /amo-button-holder_(opened|active)/.test(holder.className || '')) ||
        (btn && (btn.getAttribute('aria-expanded') === 'true' || /amo-button_(opened|active)/.test(btn.className || ''))) ||
        document.querySelector('.amo-button-holder [class*="amo-chat-window_open"], .amo-button-holder [class*="amo-chat_open"]'));
    }
    function update() {
      queued = false;
      var active = mq.matches && !chatOpen() && Array.prototype.some.call(document.querySelectorAll(selectors), visible);
      body.classList.toggle('ph-cro-buy-visible', active);
    }
    function schedule() { if (!queued) { queued = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', schedule, {passive:true});
    window.addEventListener('resize', schedule, {passive:true});
    document.addEventListener('click', schedule, true);
    document.addEventListener('change', schedule, true);
    if (mq.addEventListener) mq.addEventListener('change', schedule);
    var observer = new MutationObserver(function (records) {
      if (records.some(function(r) {return r.type === 'childList' && (r.addedNodes.length || r.removedNodes.length);})) schedule();
    });
    observer.observe(body, {childList:true,subtree:true});
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
